export default __webpack_public_path__ + "static/media/5.437e6c37.jpg";